var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-btn outer",on:{"click":function($event){$event.stopPropagation();return _vm.handleRadioBtnClick.apply(null, arguments)}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isChecked),expression:"isChecked"}],staticClass:"inner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }